var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "54",
      "height": "73"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M46.25 49.815h-7.426l-4.675-8.054a.74.74 0 0 0-.684-.359.73.73 0 0 0-.618.46l-3.289 8.383H24.28a.72.72 0 0 0-.616.345l-4.009 6.512-3.515-14.29a.72.72 0 0 0-.647-.549.72.72 0 0 0-.726.442l-3.623 8.645H1.448V7.025h44.803zm-.002 21.27h-44.8V52.798h10.178a.72.72 0 0 0 .668-.443l2.961-7.068 3.406 13.84c.07.284.303.497.592.543a.74.74 0 0 0 .729-.337l4.701-7.639h5.37a.72.72 0 0 0 .674-.46l2.921-7.448 4.131 7.117a.73.73 0 0 0 .627.361h7.843v19.82zm1.45-2.7V6.301a.724.724 0 0 0-.724-.724H.725c-.4 0-.725.325-.725.724v65.506c0 .4.325.724.725.724h46.25c.4 0 .724-.325.724-.724z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#24BA80",
      "d": "M7.878 33.204h10.813V17.23H7.878zm11.488-17.321H7.204a.674.674 0 0 0-.674.674v17.322c0 .37.302.673.674.673h12.162a.676.676 0 0 0 .674-.674V16.557a.675.675 0 0 0-.674-.674"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M24.709 18.95h17.628a.674.674 0 0 0 0-1.348h-17.63a.675.675 0 0 0 0 1.349m.002 5.897h17.628a.674.674 0 0 0 0-1.35h-17.63a.675.675 0 0 0 0 1.35m.002 5.896h13.156a.675.675 0 0 0 0-1.349H24.708a.675.675 0 0 0 0 1.349"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M51.908 0H3.73c-.74 0-1.34.6-1.34 1.339v2.838h1.32L3.73 1.3l48.216.039-.04 67.047H49.1v1.3h2.809a1.34 1.34 0 0 0 1.339-1.34V1.34A1.34 1.34 0 0 0 51.908 0"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }